@if (!editable && result) {
    @if (selectOptions.length) {
        <mat-form-field dense appearance="outline">
            <mat-select class="form-control disabled" [(value)]="result" disabled>
                @for (option of selectOptions; track option) {
                    <mat-option [value]="option.value">{{ option.name }}</mat-option>
                }
                @if (element.noApplyOption) {
                    <mat-option value="NA">No aplica</mat-option>
                }
            </mat-select>
        </mat-form-field>
    }
}

<!-- EditMode -->
@if (editable) {
    @if (selectOptions.length) {
        <mat-form-field dense appearance="outline">
            <mat-select class="form-control" #filterSelect [(value)]="result" (selectionChange)="setStar()">
                @for (option of selectOptions; track option) {
                    <mat-option [value]="option.value">{{ option.name }}</mat-option>
                }
                @if (element.noApplyOption) {
                    <mat-option value="NA">No aplica</mat-option>
                }
            </mat-select>
        </mat-form-field>
    }
}
